const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const { marketplace: marketplaceApi } = require("@doctoroncallcom/api");
const { GET_ADDRESS, CREATE_ADDRESS, UPDATE_ADDRESS } = require("./constants");

const {
  addressSuccess,
  addressError,
  createSuccess,
  createError,
  updateAddressSuccess,
  updateAddressError,
} = require("./actions");

const address = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_ADDRESS),
    mergeMap((action) =>
      marketplaceApi.customer
        .address(marketplace)
        .then((response) => addressSuccess(response.data))
        .catch((error) => addressError(error))
    )
  );

const createAddress = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(CREATE_ADDRESS),
    mergeMap((action) =>
      marketplaceApi.customer
        .createAddress(marketplace, {
          unit_no: action.payload.unitNo,
          full_address: action.payload.fullAddress,
          postcode: action.payload.postCode,
          default: action.payload.default,
        })
        .then((response) => createSuccess(response.data))
        .catch((error) => createError(error))
    )
  );

const updateAddress = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(UPDATE_ADDRESS),
    mergeMap((action) =>
      marketplaceApi.customer
        .updateAddress(marketplace, action.payload.data)
        .then((response) => updateAddressSuccess(response.data))
        .catch((error) => updateAddressError(error))
    )
  );

module.exports = {
  address,
  createAddress,
  updateAddress,
};
